import {
    START_MANUAL_BACKTEST_FAILED,
    START_MANUAL_BACKTEST_SUCCESS,
    START_MANUAL_BACKTEST_REQUEST,
    GET_OPTION_CHAIN_REQUEST,
    GET_OPTION_CHAIN_SUCCESS,
    GET_OPTION_CHAIN_FAILED,
    GET_PAY_OFF_REQUEST,
    GET_PAY_OFF_SUCCESS,
    GET_PAY_OFF_FAILED,
    EMPYT_CHART_SUCCESS,
    START_LOTSIZE_SUCCESS,
    START_LOTSIZE_FAILED,
    START_LOTSIZE_REQUEST
} from '../constants/actionTypes';

export const initialStore = {
    manualBacktestResults: {},
    dummy: {},
    expiryList: [],
    monthlyExpiryList: [],
    defaultExpiry: '',
    payoffInfo: [],
    payOffGreeks: {},
    pnlGreeks: {},
    lotSize: 0,
    standardDeviation: {},
    loading: false,
    timingLoader: false,
};

export default (state = initialStore, action) => {
    switch (action.type) {
        case START_MANUAL_BACKTEST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case START_MANUAL_BACKTEST_SUCCESS:
            return {
                ...state,
                defaultExpiry: action.data.nearest_expiry,
                dummy: action.data,
                expiryList: action.data.expiries,
                monthlyExpiryList: action.data.monthly_expiries,
                lotSize: action.data.lot_size,
            };
        case START_MANUAL_BACKTEST_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
            };
        case GET_OPTION_CHAIN_REQUEST:
            return {
                ...state,
                loading: true,
                // timingLoader: true,
            };
        case GET_OPTION_CHAIN_SUCCESS:
            return {
                ...state,
                manualBacktestResults: action.data,
                loading: false,
                // timingLoader: false,

            };
        case GET_OPTION_CHAIN_FAILED:
            return {
                ...state,
                error: true,
                loading: false,
                // timingLoader: false,
            }
        case GET_PAY_OFF_REQUEST:
            return {
                ...state,
                loading: true,
                timingLoader: true,
            };
        case GET_PAY_OFF_SUCCESS:
            return {
                ...state,
                standardDeviation: action.data.sd,
                payoffInfo: action.data.payoff,
                payOffGreeks: action.data.payoff_pnl_greeks,
                pnlGreeks: action.data.pnl_greeks,
                loading: false,
                timingLoader: false,
            };
        case GET_PAY_OFF_FAILED:
            return {
                ...state,
                error: true,
                loading: false,
                timingLoader: false,
            }
        case EMPYT_CHART_SUCCESS:
            return {
                ...state,
                payoffInfo: [],
                payOffGreeks: {},
                pnlGreeks: {},
            }
        case START_LOTSIZE_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case START_LOTSIZE_SUCCESS:
            console.log('22222222')
            state.lotSize = action.data.lot_size;
            return state
        case START_LOTSIZE_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
            }
        default:
            return state;
    }
};
